/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_UnsupportedInputs */

const en_notify_unsupported = /** @type {(inputs: Notify_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser can’t receive notifications. Add Dishly to your Home Screen.`)
};

const de_notify_unsupported = /** @type {(inputs: Notify_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Browser kann keine Mitteilungen empfangen. Installiere Dishly auf dem Home-Bildschirm.`)
};

/**
* | output |
* | --- |
* | "This browser can’t receive notifications. Add Dishly to your Home Screen." |
*
* @param {Notify_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_unsupported = /** @type {((inputs?: Notify_UnsupportedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_UnsupportedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_unsupported(inputs)
	return en_notify_unsupported(inputs)
});